import {writable} from 'svelte/store';

export type Alert = {
  type: 'success' | 'danger' | 'warning';
  message: string;
};

const createAlertStore = () => {
  const alertStore = writable<Alert>(null);
  const {set, subscribe} = alertStore;

  return {
    subscribe,
    setAlert: (alert: Alert) => {
      set(alert);
    },
    clear: () => {
      set(null);
    },
  };
};

export const alertStore = createAlertStore();
